import React from "react";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

const TestReport = ({ img, content, src }) => {
  const { t, i18n } = useTranslation();
  return (
    <Box
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: "10px",
        padding: "20px",
        paddingBottom: 0,
        fontSize: "15px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "white",
        height: "100%",
        position: "relative",
        minHeight: 180,
      }}
    >
      <img src={img} alt="" width="120" />
      <Box sx={{ pt: 2, lineHeight: "1.5em", textAlign: "center" }}>
        {content}
      </Box>

      <a download href={"/download/" + src} target="_self">
        <button
          className="custom_btn_noHover"
          style={{
            position: "absolute",
            left: 28,
            bottom: 20,
            width: "130px",
            fontSize: "11px",
            padding: "10px",
            letterSpacing: "1.0px",
          }}
        >
          {t("read_more")}
        </button>
      </a>
    </Box>
  );
};

export default TestReport;
